import english from './english.json';
import spanish from './spanish.json';

const en = {
  translation: english,
};
const es = {
  translation: spanish,
};

export default { en, es };
